/**
 * # DO NOT GIVE UNTRUSTED RULE
 *
 * @param dependancyRule DO NOT USE UNTRUSTED EXPRESSION
 * @param data condition object (can be user provided)
 */
export default function evalDependancyRule<T extends Record<string, unknown>>(
    dependancyRule: string, data: T,
): boolean {
    let result: boolean;

    try {
        // Function is cleaner to use and has better performance than eval()
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function

        // eslint-disable-next-line no-eval, no-new-func, @typescript-eslint/no-implied-eval
        result = Function(...Object.keys(data), `
            return ${dependancyRule};
        `)(...Object.values(data));
    } catch (e) {
        return false;
    }

    if (typeof result !== "boolean") {
        return false;
    }

    return result;
}
